import React, { useState } from 'react';
import LoginForm from './Login.js'
import RegistrationForm from './Registration.js'


function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <div className="App-body">
      {isLogin ? 
      <LoginForm parentIsLogin={isLogin} parentSetIsLogin={setIsLogin}/> : 
      <RegistrationForm parentIsLogin={isLogin} parentSetIsLogin={setIsLogin}/>}
      <br></br>
      <button onClick={() => setIsLogin(!isLogin)}>
        {isLogin ? "Don't have an account? Register" : "Already have an account? Login"}
      </button>
    </div>
  );
}


export default AuthPage;